import { createContext, useContext, useState } from "react";

export const RecentSearchContext = createContext();

export const RecentSearchProvider = ({ children }) => {
  const [recentSearches, setRecentSearches] = useState([]);

  const addToRecentSearches = (searchData) => {
    setRecentSearches((prev) => {
      // Generate a unique ID for the search
      const searchId = Date.now();

      // Remove duplicate searches
      const filtered = prev.filter(
        (search) =>
          !(
            search.jobQuery === searchData.jobQuery &&
            search.locationQuery === searchData.locationQuery
          )
      );

      // Add new search to the beginning
      return [{ id: searchId, ...searchData }, ...filtered].slice(0, 5);
    });
  };

  const removeRecentSearch = (searchId) => {
    setRecentSearches((prev) => prev.filter((search) => search.id !== searchId));
  };

  return (
    <RecentSearchContext.Provider
      value={{
        recentSearches,
        addToRecentSearches,
        removeRecentSearch
      }}
    >
      {children}
    </RecentSearchContext.Provider>
  );
};

export const useRecentSearches = () => {
  const context = useContext(RecentSearchContext);
  if (!context) {
    throw new Error("useRecentSearches must be used within a RecentSearchProvider");
  }
  return context;
};
